/** tempexp_14728-full-file */
import React, { FC } from 'react';
import { EViewMode } from 'reactApp/modules/settings/settings.types';
import { Checkbox } from 'reactApp/ui/DataListItemCommonComponents/Checkbox/Checkbox';
import { Download } from 'reactApp/ui/DataListItemCommonComponents/Download/Download';
import { ItemName } from 'reactApp/ui/DataListItemRow/components/ItemName/ItemName';
import { Pic } from 'reactApp/ui/DataListItemRow/components/Pic/Pic';
import { Size } from 'reactApp/ui/DataListItemRow/components/Size/Size';
import { TableColumn } from 'reactApp/ui/DataListItemRow/components/TableColumn/TableColumn';
import { StockItemProps } from 'reactApp/ui/DataListItemRow/DataListItemRow.types';

interface StockProps extends StockItemProps {
    checkboxClassname?: string;
}

export const Stock: FC<StockProps> = (props) => {
    return (
        <>
            <TableColumn>
                <Checkbox
                    viewType={EViewMode.list}
                    className={props.checkboxClassname}
                    onCheckboxClick={props.onCheckboxClick}
                    isSelected={props.isSelected}
                />
                <Pic
                    isFolder={props.isFolder}
                    thumbUrl={props.thumbUrl}
                    kind={props.kind}
                    isVirus={!!props.isVirus}
                    ext={props.ext || ''}
                    isPublic={props.isPublic}
                />
            </TableColumn>
            <TableColumn width="100%" overflow="hidden">
                <ItemName name={props.name} ext={props.ext || ''} id={props.id} />
            </TableColumn>
            <TableColumn flexBasis={132} flexShrink={0} justifyContent="center">
                <Size size={props.size} />
            </TableColumn>
            <TableColumn flexBasis={128} flexShrink={0} justifyContent="flex-end" gap={20}>
                <Download
                    onClick={props.onDownload}
                    ext={props.ext}
                    size={props.size}
                    id={props.id}
                    storage={props.storage}
                    viewType={EViewMode.list}
                />
            </TableColumn>
        </>
    );
};
